import { ArrayInput, FormDataConsumer, SimpleFormIterator } from "react-admin";
import Inputs from "./Inputs";

export default function SaleReturnItemForm() {
  return (
    <ArrayInput
      source="sale_return_items"
      defaultValue={[
        {
          // kalo tdk terlist disini input field
          // di form lain sama2 terupdate
          // saat salah satunya di rubah
          sale_id: "",
          sale_item_id: "",
          sent_quantity: "", // disabled
          return_quantity: "",
          name: "", // disabled
          price: "", // disabled
          warehouse_id: "",
        },
      ]}
    >
      <SimpleFormIterator
        disableReordering
        getItemLabel={(index) => `#${index + 1}`}
        fullWidth={true}
        sx={{
          "& .RaSimpleFormIterator-line": {
            border: "none",
          },
        }}
      >
        <FormDataConsumer>{Inputs}</FormDataConsumer>
      </SimpleFormIterator>
    </ArrayInput>
  );
}
